import * as React from "react";
import { BlogDetailHeader, BlogIntro } from "@grandvisionhq/content";
import { useIntl } from "@grandvisionhq/state";
import { withEditableContent } from "../../hocs/hocs/with-editable-content.js";
import CmsContentBlocks from "../../containers/ContentBlocks/containers/ContentBlocks/ContentBlocks.js";
import { parseBloomreachImage } from "../../utils/utils/parse-bloomreach-image.js";
const CmsBlogLayout = ({ content }) => {
  const { getLabel, locale } = useIntl();
  const { title, summary, coverImage, publishDate, readingTime, contentBlocks } = content;
  const image = parseBloomreachImage(coverImage);
  return /* @__PURE__ */ React.createElement("div", { className: "blog-layout" }, image && /* @__PURE__ */ React.createElement(
    BlogDetailHeader,
    {
      title,
      image: image.original,
      mobileImage: image.mobile,
      scrollTo: "blog-content-start"
    }
  ), summary && /* @__PURE__ */ React.createElement(
    BlogIntro,
    {
      locale,
      summary,
      publishDate,
      readingTime,
      minutesLabel: getLabel("blog.minutesToRead")
    }
  ), /* @__PURE__ */ React.createElement("article", { className: "blog-content", id: "blog-content-start" }, contentBlocks.length > 0 && /* @__PURE__ */ React.createElement(CmsContentBlocks, { contentBlocks })));
};
const CmsBlogLayout$1 = withEditableContent(CmsBlogLayout);
export {
  CmsBlogLayout,
  CmsBlogLayout$1 as default
};
//# sourceMappingURL=Blog.js.map
